import { render } from "./DashboardAddResource.vue?vue&type=template&id=6f9eb092"
import script from "./DashboardAddResource.vue?vue&type=script&lang=js"
export * from "./DashboardAddResource.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/donorsweb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__